module.exports = __webpack_public_path__ + "static/media/Individual.1016bfa7.svg";